import { useState } from "react";
import {
  Input,
  Button,
  Form,
  message,
  Select,
  Modal,
  Spin,
} from "antd";
import axios from "axios";
import "../SNdataUpdate/SNUpdate.css";
import Cookies from "js-cookie";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { AddSingleAdjustment, FindEmployeeByFileNumber } from "../../Repository/AdjustmentsRepository";
import { ErrorMessage, InfoMessage, ReplaceUnderscoreWithSpace, StringValidations, SuccessMessage, WarnMessage } from "../../Utils/Utils";

const SNUpdate = (props) => {
  const { fetchData, PayFrequency } = props;
  const jwtToken = Cookies.get("jwt_token");

  const [form] = Form.useForm();

  const [fileNumber, setFileNumber] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [AdjusmentData, setAdjustmentData] = useState([]);
  const [confirmationFlag, setConfirmationFlag] = useState(false);
  const [FrequencyUnMatchData, setFrequencyUnMatchData] = useState([]);
  const [InitialFormData, setInitialFormData] = useState();
  const [BasicMandateData, setBasicMandateData] = useState([]);
  const [HoursMandateData, setHoursMandateData] = useState([]);
  const [loading, setLoading] = useState(false); // verify loading flag

  // handle on file number search
  const handleFileNumberChange = (event) => {
    setFileNumber(event.target.value);
  };

  //Creating Objects of Columns which are mandatory
  const MandatoryFormData = (Data) => {
    let mandateFields = Data.filter(
      (data, index) =>
        data.id === "Category" ||
        data.id === "PayDate" ||
        data.id === "CoCode" ||
        // data.id === "Ticket_Number" ||
        data.id === "FileNumber" ||
        data.id === "Emp_Name" ||
        data.id === "Client"
    );
    setBasicMandateData(mandateFields);

    let requiredHOurs = ["hrs", "amount", "misc", "salary"];
    let hoursFields = Data.filter((data, index) => {
      return requiredHOurs.some((fieldsPrompt) =>
        data.id.toLowerCase().includes(fieldsPrompt)
      );
    });
    setHoursMandateData(hoursFields);
  };

  //Verify File Number
  const handleVerify = async () => {
    setLoading(true);
    try {

      if (StringValidations(fileNumber)) {
        const SearchedFileNumberData = await FindEmployeeByFileNumber(fileNumber);
        if (SearchedFileNumberData != null) {
          if (SearchedFileNumberData === "File number not Found") {
            ErrorMessage("File number not found");
          }
          else {
            //Initial Form Data
            setInitialFormData(JSON.parse(SearchedFileNumberData));
            form.setFieldsValue(JSON.parse(SearchedFileNumberData));

            //Call Frequency Validation
            ValidateFrequency(
              Object.entries(JSON.parse(SearchedFileNumberData)).map((item) => ({
                id: item[0],
                value: item[1],
              }))
            );
          }
        }
        else {
          ErrorMessage("Unable to resolve request");
        }
      }
      else{
        ErrorMessage("Please enter a file number...");
        setAdjustmentData([]);
        setIsVerified(false);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  //Confirmation Check
  const OnConfirmationProcess = () => {
    setAdjustmentData(FrequencyUnMatchData);
    setIsVerified(true);
    setConfirmationFlag(false);
  };

  const OnConfirmationCancel = () => {
    setConfirmationFlag(false);
  };

  //Check Pay Frequency
  const ValidateFrequency = async (data) => {
    var frequency = data.filter((item) => item.id === "Pay_Frequency")[0].value;

    var Status = frequency === PayFrequency;

    //Set Mandate Fields for Validation
    MandatoryFormData(data);

    if (Status) {
      setAdjustmentData(data);
      setIsVerified(Status);
    } else {
      setConfirmationFlag(true);
      setAdjustmentData([]);
      setIsVerified(Status);
      setFrequencyUnMatchData(data);
    }
  };

  //Handling adding single adjustment data
  const handleUpdate = async (values) => {
    //Validating  Hours Related Columns
    let HoursCheck = AdjusmentData.some((data, index) => {
      const isKeyMatching = HoursMandateData.some(
        (hoursData, index) => hoursData.id === data.id
      );
      const isValueEntered =
        data.value != undefined && data.value.toString().length > 0;
      return isKeyMatching && isValueEntered;
    });

    if (HoursCheck) {
      const ReFactoredToOriginal = {};
      AdjusmentData.map((item) => {
        ReFactoredToOriginal[item.id] = item.value;
      });

      //Making a request to post new adjustment data
      const Response = await AddSingleAdjustment(ReFactoredToOriginal, PayFrequency);
      if (Response != null) {
        if (Response.isSuccess === true) {
          SuccessMessage(Response.message);
          setIsVerified(false);

          setAdjustmentData([]);
        } else {
          if (Response.isTicketExist === true) {
            WarnMessage(Response.message);
          } else {
            ErrorMessage("Failed to Add Data");
            setIsVerified(false);

            setAdjustmentData([]);
          }
        }
        fetchData();
      }
      else {
        ErrorMessage("Unable to resolve request");
      }
      setFileNumber("");
    } else {
      InfoMessage("Please enter Any of the Adjustments Hours");
    }
  };

  //Handling on change in input field in adjustment form
  const handleChange = (event, id) => {
    const LatestData = AdjusmentData.map((data) => {
      if (data.id === id) {
        data.value = event.target.value;
      }
      return data;
    });
    setAdjustmentData(LatestData);
  };

  return (
    <>
      <div></div>

      <div className="search-verify">
        <div style={{ margin: "5px" }}>
          <Input
            placeholder="Search with File Number"
            value={fileNumber}
            onChange={handleFileNumberChange}
          />
        </div>
        <br />
        <div style={{ margin: "5px" }}>
          <Button
            className="verify-btn"
            onClick={handleVerify}
            disabled={PayFrequency.length === 0 || loading}
          >
            {loading ? <Spin size="small" /> : "Verify"}
          </Button>
        </div>
      </div>
      <Modal
        open={confirmationFlag}
        okText="Proceed"
        onOk={OnConfirmationProcess}
        onCancel={OnConfirmationCancel}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <ExclamationCircleOutlined
            style={{ fontSize: "20px", color: "#ffb703", marginRight: "10px" }}
          />
          <p> Are you sure want to proceed?</p>
        </div>
        <p>
          Pay Frequency of "<b>{fileNumber}</b>" is not "<b>{PayFrequency}</b>"
        </p>
      </Modal>
      <div className="adjusment-container">
        {InitialFormData ? (
          <Form
            form={form}
            onFinish={(values) => handleUpdate(values)}
            initialValues={InitialFormData}
            className="form-container "
            labelCol={{
              flex: "110px",
            }}
          >
            <div className="form-elements-container ">
              {AdjusmentData.filter(
                (item, index) =>
                  item.id != "Update_date" && item.id != "Adjustment_Status" && item.id != "Ticket_Number"
              ).map((item, index) => (
                <Form.Item
                  key={index}
                  name={item.id}
                  label={ReplaceUnderscoreWithSpace(item.id) + ":"}
                  className="sn-form-item"
                  rules={[
                    {
                      required: BasicMandateData.some(
                        (data, index) => data.id === item.id
                      ),
                      validator(rule, value) {
                        return new Promise((resolve, reject) => {
                          if (
                            BasicMandateData.some(
                              (data, index) => data.id === item.id
                            )
                          ) {
                            if (
                              value != undefined &&
                              value.toString().length > 0
                            ) {
                              resolve();
                            } else {
                              reject(`Please enter ${ReplaceUnderscoreWithSpace(item.id)}`);
                            }
                          } else {
                            resolve();
                          }
                        });
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder={ReplaceUnderscoreWithSpace(item.id)}
                    onChange={(e) => handleChange(e, item.id)}
                    disabled={!isVerified}
                    className="input-styling"
                  />
                  {/* {
                    
                  } */}
                </Form.Item>
              ))}
            </div>

            {isVerified ? (
              <div className="update-btn">
                <Button
                  className="verify-btn"
                  // onClick={() => handleUpdate()}
                  disabled={!isVerified}
                  htmlType="submit"
                >
                  Add
                </Button>
                <Button type="primary" danger onClick={() => { setAdjustmentData([]); setIsVerified(false) }}>Cancel</Button>
              </div>
            ) : (
              <></>
            )}
          </Form>
        ) : null}
      </div>
    </>
  );
};
export default SNUpdate;
